import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import DocsHeader from '../Header/DocsHeader'
import NavigationSidebar from '../Sidebar/NavigationSidebar'
import OnPageNavigation from '../OnPageNav/OnPageNavigation'
import Breadcrumb from '../Breadcrumb/Breadcrumb'
import './DocsLayout.css'

const DocsLayout = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const location = useLocation()
  const isAppsPage = location.pathname === '/platform-capabilities/apps'
  const isRegistryPage = location.pathname === '/platform-capabilities/registry'
  const isDatabasePage = location.pathname === '/platform-capabilities/database'
  const isVPSPage = location.pathname === '/platform-capabilities/vps'
  const isBillingPage = location.pathname === '/account/billing'
  const isUsagePage = location.pathname === '/account/usage'
  const isCommunityPage = location.pathname === '/resources/community'
  const isWelcomePage = location.pathname === '/'
  const isQuickStartPage = location.pathname === '/quick-start'
  const isAPIKeysPage = location.pathname === '/resources/api-keys'
  const isVSCodeExtensionPage = location.pathname === '/resources/vscode-extension'
  const isCLIPage = location.pathname === '/resources/cli'
  const isFAQPage = location.pathname === '/resources/faq'
  const isSupportPage = location.pathname === '/resources/support'
  const hasCustomSidebar = isAppsPage || isRegistryPage || isDatabasePage || isVPSPage || isBillingPage || isUsagePage || isCommunityPage || isWelcomePage || isQuickStartPage || isAPIKeysPage || isVSCodeExtensionPage || isCLIPage || isFAQPage || isSupportPage

  useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [location])

  return (
    <div className="docs-layout">
      <DocsHeader 
        onMobileMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        isMobileMenuOpen={isMobileMenuOpen}
      />
      <div className="docs-layout-container">
        <NavigationSidebar isMobileMenuOpen={isMobileMenuOpen} />
        <div className="docs-main-wrapper">
          <div className="docs-breadcrumb-wrapper">
            <Breadcrumb />
          </div>
        <main className={`docs-content-wrapper ${hasCustomSidebar ? 'custom-sidebar-layout' : ''}`}>
          <div className="docs-content">
            {children}
          </div>
          {!hasCustomSidebar && <OnPageNavigation />}
        </main>
        </div>
      </div>
    </div>
  )
}

export default DocsLayout
